export default __webpack_public_path__ + "static/media/Executive-Summary.b6841862.svg";